import React from "react"
import PromotionBannerConnector from "./PromotionBannerConnector"

const PromotionBannersWrapper = ({activePromotionBanners, location, editedLocale, pageContext}) => {
  if(activePromotionBanners?.length === 0) return null
  return activePromotionBanners?.map((banner, i) => {
    return (<PromotionBannerConnector
      location={location}
      promotionBanner={banner}
      locale={editedLocale}
      pageContext={pageContext}
      key={i}
      />
    )
  })
}

export default PromotionBannersWrapper